module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-area"
  }, [(!_vm.charts.length) ? _c('div', {
    staticClass: "loading-msg"
  }, [_vm._v(_vm._s(_vm.lang.interface.loading))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.charts), function(chart) {
    return _c('AnimeChart', {
      key: "chart.id",
      attrs: {
        "data": chart,
        "lang": _vm.lang
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa63786","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainView.vue
// module id = 69
// module chunks = 4